import Heart from '../../Heart';
import Furniture from './Furniture';

export default class Owl extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.canTap = true;

    //
    this.asset.setMixByName('day', 'day2night', 0.2);
    this.asset.setMixByName('day2night', 'night', 0.2);
    this.asset.setMixByName('night', 'day', 0.2);
    this.asset.setMixByName('tap', 'day', 0.2);
    this.asset.setMixByName('tap', 'night', 0.2);
    this.setAnim('day');

    //
    this.rootBone.scaleX = 1.1;
    this.rootBone.scaleY = 1.1;
  }

  //
  setNight(instant) {
    if (instant) {
      this.setAnim('night');
    } else {
      this.setAnim('day2night');
      this.asset.addAnimationByName(0, 'night', true);

      // show heart
      if (this.worldPosition.x > 10 && this.visible) {
        this.game.time.events.add(1000, this.showHeart, this);
      }
    }
  }

  setDay() {
    this.setAnim('day');
  }

  handleInputDown() {
    // can tap only at night
    if (this.canTap && !this.location.isDay()) {
      this.canTap = false;
      this.setAnim('tap');
      this.asset.onComplete.addOnce(this.handleTapAnimEnd, this);

      this.game.sounds.playSFX('item_owl', { spriteID: 'sfx' });
    }
  }

  handleTapAnimEnd() {
    this.canTap = true;
    if (this.location.isDay()) {
      this.setAnim('day');
    } else {
      this.setAnim('night');
    }
  }

  showHeart() {
    const heart = new Heart(this.game, -30, -490);
    this.addChild(heart);
  }
}
